import React, { useState } from 'react';
import styled from 'styled-components';
import { CloudUpload } from '@mui/icons-material';
import { Typography, Button } from '@mui/material';

const DropzoneContainer = styled.div`
  border: 2px dashed ${props => props.$isDragging ? props.theme.colors.primary : '#ccc'};
  border-radius: ${props => props.theme.borderRadius};
  padding: 40px;
  text-align: center;
  background-color: ${props => props.$isDragging ? '#f0f7ff' : '#fafafa'};
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: ${props => props.theme.colors.primary};
    background-color: #f0f7ff;
  }
`;

const UploadIcon = styled(CloudUpload)`
  font-size: 64px;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 20px;
`;

const HiddenInput = styled.input`
  display: none;
`;

const FileInfo = styled.div`
  margin-top: 20px;
  padding: 15px;
  background-color: #e8f4f8;
  border-radius: ${props => props.theme.borderRadius};
`;

function FileDropzone({ onFileSelect, selectedFile }) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.name.endsWith('.zip')) {
        onFileSelect(file);
      } else {
        alert('Please upload a .zip file');
      }
    }
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.name.endsWith('.zip')) {
        onFileSelect(file);
      } else {
        alert('Please upload a .zip file');
      }
    }
  };

  const handleClick = () => {
    document.getElementById('file-input').click();
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <div>
      <DropzoneContainer
        $isDragging={isDragging}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        <UploadIcon />
        <Typography variant="h6" gutterBottom>
          Drag and drop your Letterboxd export here
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          or click to browse
        </Typography>
        <Button variant="outlined" color="primary" style={{ marginTop: '20px' }}>
          Choose File
        </Button>
        <Typography variant="caption" display="block" style={{ marginTop: '10px', color: '#666' }}>
          Accepts .zip files only
        </Typography>
      </DropzoneContainer>

      <HiddenInput
        id="file-input"
        type="file"
        accept=".zip"
        onChange={handleFileChange}
      />

      {selectedFile && (
        <FileInfo>
          <Typography variant="body1">
            <strong>Selected file:</strong> {selectedFile.name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Size: {formatFileSize(selectedFile.size)}
          </Typography>
        </FileInfo>
      )}
    </div>
  );
}

export default FileDropzone;
